// extracted by mini-css-extract-plugin
export var card = "_8g-1";
export var container = "_8g-0";